import React from "react";

enum StorageKeys {
  status= "lvs_lastVisibilityStatus",
  time= "lvs_lastVisibilityStatusTime",
}

const VisibilityHandling = () => {
  React.useEffect(() => {
    document.addEventListener('visibilitychange', () => {
      const lastVisibilityStatus =  window.sessionStorage.getItem(StorageKeys.status);
      const lastVisibilityStatusTime =  window.sessionStorage.getItem(StorageKeys.time);

      window.sessionStorage.setItem(StorageKeys.status, document.visibilityState);
      window.sessionStorage.setItem(StorageKeys.time, String(Date.now()));
      console.info("level 1", lastVisibilityStatus, lastVisibilityStatusTime);
      if (lastVisibilityStatus == 'hidden' && document.visibilityState == 'visible') {
        console.info("level 2", lastVisibilityStatus);
        try {
          let diff = 0;
          const currentTimeStamp = Date.now()
          diff = currentTimeStamp - parseInt(lastVisibilityStatusTime);
          console.info("level 3", currentTimeStamp, lastVisibilityStatusTime, diff);
          if (window.location.href.includes('/app/pulse-of-india')) {
            if (diff > 60*0.5*1000) {
              console.info("level 7", lastVisibilityStatus);
              window.location.reload();
            }
          }
        } catch (err) {
          console.info("level 8", lastVisibilityStatus);
        }
      }
    });
  });

  return null;
};

export default VisibilityHandling;